import { createListenerMiddleware } from '@reduxjs/toolkit';

import { RootState } from 'store';

import { getBtcProvider, TBtcWalletId } from 'modules/api';
import { connectBtc, selectBtcConnect } from './actions/connectBtc';
import { disconnectBtc } from './actions/disconnectBtc';
import { BTC_CONNECTION_CACHE_KEY } from './const';

/**
 * @description
 * This middleware listens for the account change event from the BTC provider
 * and disconnects the BTC connection if the account changes.
 */
export const btcListenerMiddleware = createListenerMiddleware();
btcListenerMiddleware.startListening({
  predicate: action => {
    return !!connectBtc?.matchFulfilled(action);
  },

  effect: async (_action, api) => {
    api.cancelActiveListeners();

    if (!_action.walletId) {
      return;
    }

    const provider = await getBtcProvider(_action.walletId as TBtcWalletId);
    const eventProvider = provider.injectedProvider;

    if (!eventProvider) {
      return;
    }

    const accountChangeCallback = () => {
      const state = api.getState() as RootState;
      const { data: connectionData } = selectBtcConnect(state);
      const walletId = connectionData?.walletId;

      if (!connectionData?.isActive || !walletId) return;

      const disconnectBtcThunk = disconnectBtc.initiate(walletId, {
        fixedCacheKey: BTC_CONNECTION_CACHE_KEY,
      });

      const btcResult = api.dispatch(disconnectBtcThunk);
      btcResult.reset();
    };

    // Remove the account change listener if it exists
    eventProvider.removeAccountChangeListener(accountChangeCallback);

    // Add the account change listener
    eventProvider.onAccountChange(accountChangeCallback);
  },
});
